module.exports = __webpack_public_path__ + "resources/img/sp_tcc_m.30148ddae22bc5b0944b8e937f6d382e.png";